/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const ArrowUpCircle: React.FC<Props> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.71094 5.36035C9.93702 5.22869 10.2268 5.2503 10.4316 5.42578L14.0195 8.50098C14.2812 8.72564 14.3113 9.1199 14.0869 9.38184C13.8624 9.64354 13.4681 9.6743 13.2061 9.4502L10.6504 7.25879V14.1006C10.6501 14.4454 10.3702 14.7254 10.0254 14.7256C9.68041 14.7256 9.40071 14.4455 9.40039 14.1006V7.25879L6.84473 9.4502C6.58272 9.67459 6.18751 9.64364 5.96289 9.38184C5.7386 9.11993 5.76875 8.72563 6.03027 8.50098L9.61816 5.42578L9.71094 5.36035Z"
      fill={color || props.style?.color || 'black'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.166 1.41504C14.9981 1.41529 18.9158 5.33293 18.916 10.165C18.9158 14.9971 14.9981 18.9148 10.166 18.915C5.33386 18.9149 1.41619 14.9972 1.41602 10.165C1.41618 5.33288 5.33386 1.41521 10.166 1.41504ZM10.166 2.86035C6.13187 2.86052 2.8615 6.13089 2.86133 10.165C2.8615 14.1992 6.13187 17.4705 10.166 17.4707C14.2001 17.4704 17.4705 14.1991 17.4707 10.165C17.4705 6.13095 14.2001 2.86061 10.166 2.86035Z"
      fill={color || props.style?.color || 'black'}
    />
  </svg>
);

export default ArrowUpCircle;
